import React from "react";
import { CheckCircleIcon } from "@heroicons/react/24/solid";

export default function ClaimSuccess() {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-slate-900 to-black px-4 py-10 text-white">
            <div className="bg-white text-center text-gray-800 p-8 rounded-2xl shadow-xl max-w-md w-full">
                <div className="flex justify-center mb-6 animate-bounce-slow">
                    <CheckCircleIcon className="h-20 w-20 text-green-500" />
                </div>
                <h2 className="text-3xl font-bold mb-2">Service Request Submitted Successfully</h2>
                <p className="text-gray-600 mb-4">
                    You will receive further communication on WhatsApp regarding the process.
                </p>
            </div>
        </div>
    );
}
